// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"161":"ccb179ca","478":"687dd458","562":"f74cda6a","723":"445d8c73","922":"fefd4601","964":"477484b8"}[chunkId] + ".chunk.js";
};